import { render } from "./SauterList.vue?vue&type=template&id=73dbdb91"
import script from "./SauterList.vue?vue&type=script&lang=js"
export * from "./SauterList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__